import React, { useEffect, useState } from 'react';
import API from "../../src/services/api";
import NoDataFound from '../shared/NoDataFound';
import TableLoader from '../shared/TableLoader';
import Paginator from '../shared/Paginator';
import config from '../config';
import '../components/creatives/CreativeList.scss';

const DownloadCreativePreviews = () => {
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [paginatedData, setPaginatedData] = useState([]);

    const fetchProcessData = async (page = 0) => {
        setLoader(true);
        try {
            let res = await API({
                url: "/lineitems/getProcessdata",
                method: 'POST',
                responseType: 'json',
            });

            const allData = res.data;
            setData(allData);
            setTotalPages(Math.ceil(allData.length / config.PER_PAGE));

            // Calculate the slice of data for the current page
            const startIndex = page * config.PER_PAGE;
            const endIndex = startIndex + config.PER_PAGE;
            setPaginatedData(allData.slice(startIndex, endIndex));
        } catch (error) {
            console.error('Error fetching process data:', error);
        }
        setLoader(false);
    };

    const handlePageClick = (event) => {
        const newPage = event.selected;
        setCurrentPage(newPage);

        // Calculate new slice of data
        const startIndex = newPage * config.PER_PAGE;
        const endIndex = startIndex + config.PER_PAGE;
        setPaginatedData(data.slice(startIndex, endIndex));
    };

    useEffect(() => {
        fetchProcessData(0);
    }, []);

    const formatDate = (timestamp) => {
        if (timestamp == 0) return 'Not Completed'
        const date = new Date(timestamp * 1000);
        return date.toLocaleString();
    };

    const renderStatus = (status) => {
        const map = {
            0: { label: "Pending", cls: "cl-chip--pending" },
            1: { label: "Ready for Download", cls: "cl-chip--ready" },
            2: { label: "Failed", cls: "cl-chip--failed" },
            3: { label: "Expired", cls: "cl-chip--expired" },
        };
        const s = map[status];
        if (!s) return "-";
        return <span className={`cl-chip ${s.cls}`}>{s.label}</span>;
    };

    return (
        <div className="creativeListPage">
            <div className="cl-card">
                <header className="cl-header">
                    <div className="cl-title-block">
                        <h1 className="cl-title">Download Creative Previews</h1>
                        <p className="cl-subtitle">Track and download your requested creative preview exports</p>
                    </div>
                </header>

                <div className="cl-table-wrap">
                    <table className="cl-table">
                        <thead>
                            <tr>
                                <th>User Name</th>
                                <th>User Department</th>
                                <th>Status</th>
                                <th>Download Request ID</th>
                                <th>Location</th>
                                <th>Interval</th>
                                <th>Process ID</th>
                                <th>Created Date</th>
                                <th>Completed At</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        {(paginatedData?.length && !loader) ? (
                            <tbody>
                                {paginatedData.map((item) => (
                                    <tr key={item.process_id}>
                                        <td className="cl-name" data-label="User Name">{item.user_name}</td>
                                        <td data-label="User Department">{item.user_department || '-'}</td>
                                        <td data-label="Status">{renderStatus(item.status)}</td>
                                        <td data-label="Download Request ID">{item.download_request}</td>
                                        <td data-label="Location">{item.location || "-"}</td>
                                        <td data-label="Interval">{item.interval}</td>
                                        <td data-label="Process ID">{item.process_id}</td>
                                        <td data-label="Created Date">{formatDate(item.download_request)}</td>
                                        <td data-label="Completed At">{formatDate(item.complete_request)}</td>
                                        <td data-label="Action">
                                            {item.status === 1 && (
                                                <a
                                                    href={`${config.BASE_URL}creative_zipfiles/${item.process_id}_${item.location}.zip`}
                                                    download
                                                    className="cl-download-btn"
                                                >
                                                    <sl-icon library="lucide" name="download"></sl-icon>
                                                    Download
                                                </a>
                                            )}
                                            {item.status === "2" && (
                                                <span className="cl-muted-danger">Failed</span>
                                            )}
                                            {item.status === "3" && (
                                                <span className="cl-muted-danger">Expired</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        ) : (
                            !paginatedData?.length && !loader
                                ? <NoDataFound colspan="10" />
                                : <TableLoader colspan="10" />
                        )}
                    </table>
                </div>
            </div>
            {totalPages > 1 && (
                <div className="cl-pagination">
                    <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />
                </div>
            )}
        </div>
    );
};

export default DownloadCreativePreviews;
